import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { useGeo } from "../lib/locale";
import ListingCard from "../components/ListingCard";

export default function Profile() {
  const { userId } = useParams();
  const { user } = useAuth();
  const geo = useGeo();
  const [profile, setProfile] = useState(null);
  const [listings, setListings] = useState([]);

  const targetId = userId || user?.user_id;

  useEffect(() => {
    if (!targetId) return;
    api.get(`/users/${targetId}`).then((r) => setProfile(r.data)).catch(() => {});
    api.get(`/users/${targetId}/listings`).then((r) => setListings(r.data || []));
  }, [targetId]);

  if (!profile) return <div className="pbp-section py-20 text-center text-[#86868b]">Loading…</div>;

  return (
    <div className="pbp-section py-10 md:py-16">
      <div className="pbp-card p-6 md:p-8 flex flex-col sm:flex-row items-center sm:items-start gap-6">
        {profile.picture ? (
          <img src={profile.picture} alt="" className="w-20 h-20 rounded-full object-cover" />
        ) : (
          <div className="w-20 h-20 rounded-full bg-[#0071e3] grid place-items-center text-white text-2xl font-semibold">
            {profile.name?.[0]?.toUpperCase()}
          </div>
        )}
        <div className="flex-1">
          <h1 className="text-2xl font-semibold tracking-tight">{profile.name}</h1>
          <div className="text-sm text-[#86868b] mt-1">
            {profile.city && `${profile.city}, `}{profile.country || "Earth"} · Joined {new Date(profile.created_at).toLocaleDateString()}
          </div>
          <div className="mt-3 flex gap-3 text-sm text-[#1d1d1f]/80">
            <span><b>{profile.listing_count || 0}</b> listings</span>
            <span>· <b>{(profile.rating || 5).toFixed(1)}</b> rating</span>
          </div>
        </div>
        {user?.user_id === profile.user_id && (
          <Link to="/sell" className="pbp-btn-primary">+ New listing</Link>
        )}
      </div>

      <h2 className="mt-10 text-xl font-semibold tracking-tight">Active listings</h2>
      <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {listings.length === 0 ? (
          <div className="pbp-card p-8 text-[#86868b]">No active listings.</div>
        ) : (
          listings.map((l) => <ListingCard key={l.listing_id} listing={l} geoCountryCode={geo?.country_code} />)
        )}
      </div>
    </div>
  );
}
